// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1927":"1eff37ee","2375":"555e2f1b","2620":"6cc263d7","3380":"8c916367","3410":"1b9294a0","4423":"8c916367","4794":"ef38f7a1","6549":"1b9294a0","7876":"cc98c50d","8473":"fc16faa4"}[chunkId] + ".chunk.css";
};